
import ListView from './listview'
import Search from 'vux/src/components/search/index.vue'

const HOT_NAME = '#'
export default {
data() {
return {
singers:[],
address:[],
serach:"",
dataca:this.datac,
jbStorage:JSON.parse(localStorage.getItem("jbStorage")) || {}
}
},
created() {
this._getSingerList()

},
props:['datac','flagvalue'],
computed:{
singersc:function(){
var search = this.serach;
if (search){
return this._normalizeSinger(this.datac.filter(function(product){
return Object.keys(product).some(function(key){
return String(product[key]).toLowerCase().indexOf(search) > -1
})
}))
}
return this.singers;
}
},
methods:{
handlePlaylist(playlist) {
const bottom = playlist.length > 0 ? '60px' : ''
this.$refs.city.style.bottom = bottom
this.$refs.list.refresh()
},
selectc(ac){
this.jbStorage.city = ac
if(this.$until.getUrlParam("downvalue")){
this.jbStorage.downvalue =  ac;
}
if (this.$until.getUrlParam('stag') == 'start'){
this.jbStorage.start = ac.name
}
if (this.$until.getUrlParam('stag') == 'end'){
this.jbStorage.end = ac.name
}
localStorage.setItem("jbStorage",JSON.stringify(this.jbStorage));
if (this.$until.getUrlParam('stag')){

this.$router.push('/' + this.$until.getUrlParam('back') + '?tabIndex=1')
}else{

if(decodeURIComponent(this.$until.getUrlParam('back')).indexOf("from") != '-1' || decodeURIComponent(this.$until.getUrlParam('back')).indexOf("label") != '-1'){

this.$router.push(decodeURIComponent(this.$until.getUrlParam('back')).substr(1,decodeURIComponent(this.$until.getUrlParam('back')).length))
}else{
this.$router.push(decodeURIComponent(this.$until.getUrlParam('back')).substr(0,decodeURIComponent(this.$until.getUrlParam('back')).length))
}
}
},
_getSingerList() {
this.singers = this._normalizeSinger(this.datac)
},
_normalizeSinger(list) {

if (!list){
return
}
let map = {}
list.forEach((item,index) =>{
const key = ((item.enCityName || item.enName || item.shortPy).substr(0,1)).toUpperCase()
if (!map[key]){
map[key] = {
title:key,
items:[]
}
}
map[key].items.push({
name:item.cityName,
id:item.cityNo || item.airportNo,
full_name:item.enName || item.fullPy,
short_name:item.enCityName || item.enName || item.shortPy,
siteName:item.siteName,
siteNo:item.siteNo
})
})
let ret = []
let hot = []
for(let key in map) {
let val = map[key]
if (val.title.match(/[a-zA-Z]/)){
ret.push(val)
} else if (val.title === HOT_NAME){
}
}
ret.sort((a,b) =>{
return a.title.charCodeAt(0) - b.title.charCodeAt(0)
})
return hot.concat(ret)
}
},
components:{
ListView
},
watch:{
'$route' (to,from) {

}
},
}




// WEBPACK FOOTER //
// ./src/components/common/city.vue